import { render, staticRenderFns } from "./ContenidoCard.vue?vue&type=template&id=b679b454&scoped=true"
import script from "./ContenidoCard.vue?vue&type=script&lang=js"
export * from "./ContenidoCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b679b454",
  null
  
)

export default component.exports